import React from "react";

import { Flex } from "antd";

import { ExperimentFinalizeSection } from "../components/finalize/ExperimentFinalizeSection";
import { useExperimentEditor } from "../hooks/useExperimentEditor";

export const ExperimentFinalizePage: React.FC = () => {
  const {
    experimentData,
    goToStepByIndex,
    isFinalized,
    setIsFinalized,
  } = useExperimentEditor();

  return (
    <Flex vertical style={{ flex: 1, overflow: "hidden" }}>
      <ExperimentFinalizeSection
        experimentData={experimentData}
        goToStep={goToStepByIndex}
        isFinalized={isFinalized}
        setIsFinalized={setIsFinalized}
      />
    </Flex>
  );
};

export default ExperimentFinalizePage;
